module.exports = __webpack_public_path__ + "static/media/brasao_sspds.0bbcd682.png";